import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ptBrLocale from 'element-ui/lib/locale/lang/pt-br'

// 用 Vue.observable 让 locale 数据变成响应式
const elementLang = Vue.observable({ current: 'zh' })

export function setElementLocale(lang) {
  if (lang === 'zh') {
    locale.use(zhLocale)
  } else {
    locale.use(ptBrLocale)
  }
  elementLang.current = lang
}

export function initElementLocale(lang) {
  setElementLocale(lang)
}

// 提供给 mixin 使用的响应式标识
export function getElementLang() {
  return elementLang.current
}

// 全局 mixin：在包含 el-pagination 的组件中，
// 读取 elementLang.current 建立响应式依赖，
// 当 setElementLocale 改变值时自动触发 $forceUpdate
Vue.mixin({
  computed: {
    __elementLocaleKey() {
      return elementLang.current
    }
  },
  watch: {
    __elementLocaleKey() {
      this.$forceUpdate()
    }
  }
})


